// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3pTRL","buttons":"PendingPaymentAlert_buttons__f0xPY"};